import { useState } from 'react';

/**
 * IP abreviada para tablas: IPv4 -> primeros 2 octetos ("190.85.…"), IPv6 -> primeros 2 bloques
 * ("2800:484:…"). Así una IPv6 completa no estira la columna letra por letra. Con `expandable`
 * se puede ver la IP completa ("ver más"); el título (tooltip) siempre la trae completa.
 */
export function shortIp(ip: string): string {
  const v = ip.trim();
  if (v.includes(':')) {
    const parts = v.split(':').filter(Boolean);
    return parts.length > 2 ? `${parts.slice(0, 2).join(':')}:…` : v;
  }
  const parts = v.split('.');
  return parts.length === 4 ? `${parts[0]}.${parts[1]}.…` : v;
}

export function IpText({ ip, expandable = false }: { ip: string | null | undefined; expandable?: boolean }) {
  const [open, setOpen] = useState(false);
  const value = (ip ?? '').trim();
  if (!value) return <span className="text-ink-300">—</span>;
  const short = shortIp(value);
  const canExpand = expandable && short !== value;
  return (
    <span className="inline-flex flex-col items-start font-mono text-xs" title={value}>
      <span className={open ? 'block min-w-[12rem] max-w-[16rem] break-all' : 'whitespace-nowrap'}>{open ? value : short}</span>
      {canExpand && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((o) => !o);
          }}
          className="mt-0.5 whitespace-nowrap font-sans text-xs font-semibold text-brand-600 hover:underline"
        >
          {open ? 'ver menos ▴' : 'ver más ▾'}
        </button>
      )}
    </span>
  );
}
